module.exports = __webpack_public_path__ + "assets/img/4.a2a99abf.png";